import { HttpError } from '@magiczne/http-client'
import Vue from 'vue'

import NotFoundError from '@/common/errors/not-found-error'
import * as ErrorHandlers from '@/common/lib/error-handlers'

Vue.config.errorHandler = async function (err, vm) {
    if (process.env.NODE_ENV === 'development') {
        console.debug(err)
    }

    if (err.name === NotFoundError.name) {
        await ErrorHandlers.handleNotFound(vm)
    } else if (HttpError.isHttpError(err) && err.response) {
        const handlers: Record<number, ErrorHandlers.ErrorHandler | ErrorHandlers.ResponseErrorHandler> = {
            404: ErrorHandlers.handleNotFound,
            429: ErrorHandlers.handleTooManyRequests,
            503: ErrorHandlers.handleServiceUnavailable,
        }

        if (err.response.status in handlers) {
            await handlers[err.response.status](vm, err.response)
        } else {
            await ErrorHandlers.handleUndefinedError(vm)
        }
    } else {
        await ErrorHandlers.handleUndefinedError(vm)
    }
}
